<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Bukti Gadai</h5>
            </template>
            <div class="big-filter-label filter-form-wrapper mb-3">
                <b-row>
                    <b-col md="12" lg="9">
                        <b-form-group class="form-inline" label-for="filterNoFaktur" label="No. Faktur">
                            <b-form-input v-model="input.filterNoFaktur" name="filterNoFaktur" type="search"
                                id="filterNoFaktur" placeholder="Masukkan no. faktur"></b-form-input>
                        </b-form-group>

                        <b-form-group class="form-inline" label-for="filterStatus" label="Status">
                            <b-form-select v-model="input.filterStatus" id="filterStatus" name="tipe" value-field="id"
                                text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>-- Pilih Tipe --</b-form-select-option>
                                    <b-form-select-option :value="1">Pending SBG Awal</b-form-select-option>
                                    <b-form-select-option :value="2">Pending Berkas Pelunasan</b-form-select-option>
                                    <b-form-select-option :value="10">Menunggu Pelunasan</b-form-select-option>
                                    <b-form-select-option :value="99">Lengkap</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterTipePelunasan" label="Tipe Pelunasan">
                            <b-form-select v-model="input.filterTipePelunasan" id="filterTipePelunasan" name="tipe"
                                value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>-- Pilih Tipe --</b-form-select-option>
                                    <b-form-select-option :value="1">Nasabah + SBG</b-form-select-option>
                                    <b-form-select-option :value="2">Nasabah + Nota Hilang</b-form-select-option>
                                    <b-form-select-option :value="3">Pelunasan Diwakilkan + SBG</b-form-select-option>
                                    <b-form-select-option :value="4">Pelunasan Diwakilkan + Surat Kuasa PGI (Apabila SBG Hilang)</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>

                        <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal Pelunasan">
                            <div class="d-flex search-input-wrapper">
                                <b-form-input v-model="input.filterStartDate" name="filterStartDate" id="filterDate"
                                    type="date"></b-form-input>
                                <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                <b-form-input v-model="input.filterEndDate" name="filterEndDate" type="date"></b-form-input>
                            </div>
                        </b-form-group>

                    </b-col>
                    <b-col cols="12">
                        <div class="filter-btn-wrapper">
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy"
                                @click="onFilter()">
                                Search
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy"
                                @click="onReset">Reset</b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table bordered hover show-empty :busy="isBusy" :items="daftarPelunasan" :fields="fields"
                :no-local-sorting="false" @sort-changed="sortingChanged" responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data gadai.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    <p class="mb-0">{{ row.item.noFaktur }}</p>
                    <p class="mb-0 smallText text-muted">{{ row.item.cabang }}</p>
                </template>
                <template v-slot:cell(jumlahPinjaman)="row">
                    <div class="text-right no-wrap">
                        <p class="mb-0" v-if="row.item.jumlahPinjaman !== null">Rp.
                            {{ $helper.addThousandSeparator(row.item.jumlahPinjaman) }} </p>
                        <p class="mb-0" v-else>{{ $helper.addThousandSeparator(row.item.jumlahPinjaman) }} </p>
                    </div>
                </template>
                <template v-slot:cell(barang)="row">
                    <div v-if="row.item.jenisPinjaman == 'Kendaraan'">
                        <p class="mb-0">{{ row.item.jenis }}</p>
                        <p class="mb-0 smallText text-muted">{{ row.item.merk }} - {{ row.item.tipe }}</p>
                    </div>
                    <div v-else>
                        <p class="mb-0">{{ row.item.tipe }}</p>
                        <p class="mb-0 smallText text-muted">{{ row.item.jenis }} - {{ row.item.merk }}</p>
                    </div>
                </template>
                <template v-slot:cell(tanggalPelunasan)="row">
                    <div v-if="row.item.tanggalPelunasan != null">
                        <div>{{ $helper.changeDateFormat(row.item.tanggalPelunasan) }}</div>
                        <div class="smallText text-muted">{{ $helper.changeDateFormatGetHour(row.item.tanggalPelunasan) }}
                        </div>
                    </div>
                    <div v-else>-</div>
                </template>
                <template v-slot:cell(status)="row">
                    <div v-if="row.item.status == 1">Pending SBG Awal</div>
                    <div v-if="row.item.status == 2">Pending Berkas Pelunasan</div>
                    <div v-if="row.item.status == 10">Menunggu Pelunasan</div>
                    <div v-if="row.item.status == 99">Lengkap</div>
                    <div class="smallText text-muted">Bukti terupload : {{ row.item.photoCount }}</div>
                </template>
                <template v-slot:cell(tipePelunasan)="row">
                    <div v-if="row.item.tipePelunasan == 1">Nasabah + SBG</div>
                    <div v-if="row.item.tipePelunasan == 2">Nasabah + Nota Hilang</div>
                    <div v-if="row.item.tipePelunasan == 3">Pelunasan Diwakilkan + SBG</div>
                    <div v-if="row.item.tipePelunasan == 4">Pelunasan Diwakilkan + Surat Kuasa PGI (Apabila SBG Hilang)</div>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-button size="sm" variant="pgiBtn" name="bayarBtn" v-b-tooltip.hover title="Upload Bukti"
                            @click="uploadBukti(row.item.id, row.item.noFaktur, row.item.status)">
                            <i class="fa fa-picture-o" aria-hidden="true"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0" v-model="currentPage" :total-rows="rows" :per-page="perPage"
                    aria-controls="my-table" @input="onPageChange"></b-pagination>
            </div>

            <b-modal id="modal-detail" title="Detail Bukti" no-close-on-esc no-close-on-backdrop>
                <div v-if="loadDetail">
                    <div class="text-center my-2">
                        Mengambil data, mohon menunggu...
                    </div>
                </div>
                <div v-else>
                    <div v-if="activeItem != null">
                        <p>
                            No. Faktur : {{ activeItem.noFaktur }}
                        </p>
                        <p v-if="activeItem.notaHilangCode">
                            Kode Nota Hilang : {{ activeItem.notaHilangCode }}
                        </p>
                        <div v-for="item of activeItem.evidences" class="my-2">
                            <strong>
                                {{ item.name }}
                            </strong>
                            <div class="d-flex">
                                <b-button class="mr-2" v-if="item.path != null" variant="cancelBtn" @click="viewFoto(item)">
                                    Lihat Bukti
                                </b-button>
                                <p v-else>Bukti tidak diupload</p>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button variant="pgiBtn" name="cancelAjukanAngsuranSajaBtn" @click="cancel()">
                        Tutup
                    </b-button>
                </template>
            </b-modal>

            <b-modal id="modal-preview-foto" size="xl" :title="activeFotoPreview.name">
                <div v-if="activeItem">
                    No. Faktur : {{ activeItem.noFaktur }}
                </div>
                <div class="my-2">
                    Oleh : {{ activeFotoPreview.createdBy }} , {{ $helper.changeDateFormat(activeFotoPreview.createdAt) }}
                    {{
                        $helper.changeDateFormatGetHour(activeFotoPreview.createdAt) }}
                </div>
                <div class="modal-foto-wrapper">
                    <iframe
                        v-if="isPdfFile(activeFotoPreview)"
                        :src="activeFotoPreview.path"
                        title="Preview Bukti"
                        class="preview-pdf"
                    ></iframe>
                    <img v-else :src="activeFotoPreview.path" alt="Bukti">
                </div>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                        Close
                    </b-button>
                </template>
            </b-modal>

            <b-modal id="modal-upload-bukti" title="Upload Bukti" no-close-on-backdrop
                @close="shouldRefresh && getBuktiGadai()" @cancel="shouldRefresh && getBuktiGadai()">
                <div v-if="loadDetail">
                    <div class="text-center my-2">
                        Mengambil data, mohon menunggu...
                    </div>
                </div>
                <div v-else class="mb-3">
                    No. Faktur : {{ activeFaktur }}
                    <div v-for="item of required" class="my-2" v-if="required.length != 0">
                        {{ item.name }} <span v-if="item.isRequired" class="text-danger">*</span>
                        <div class="upload-gadai-btn-wrapper">
                            <b-button class="upload-gadai-btn" v-if="item.path != null" variant="cancelBtn" @click="viewFoto(item)">
                                Lihat Bukti
                            </b-button>

                            <!-- MOBILE -->
                            <div class="cameraMobileWrapper upload-gadai-btn">
                                <b-button class="upload-gadai-btn" variant="cancelBtn" @click="onCamera(item)">
                                    <i class="fa fa-camera mr-1"></i>
                                    {{ (item.path != null) ? 'Update Bukti' : 'Camera' }}
                                </b-button>
                            </div>
                            <!-- MOBILE -->

                            <div class="browse-foto upload-gadai-btn">
                                <b-form-file v-model="item.file" name="fotoBarangPendukung" :state="Boolean(item.file)"
                                    drop-placeholder="Drop file here..." accept=".jpg, .png, .jpeg, .pdf"
                                    @input="browseFile(item.type, item.file, (item.path != null) && true, item.id)">
                                </b-form-file>
                                <b-button variant="cancelBtn" class="upload-gadai-btn">
                                    <i class="fa fa-upload mr-1"></i>
                                    {{ (item.path != null) ? 'Update Bukti' : 'Upload Bukti' }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <b-alert
                    :show="selectedStatus == 2" 
                    variant="info"
                    class="alert-wrapper"
                >
                    <div class="d-flex">
                        <i class="fa fa-info mr-3 mt-1"></i>
                        <p class="mb-0">
                            Bila menurut anda bukti sudah lengkap, namun status belum berubah menjadi 'Lengkap', silahkan tekan tombol <strong>Refresh Status Lengkap</strong>.
                        </p>
                    </div>
                </b-alert>

                <template v-slot:modal-footer="{ cancel }">
                    <b-button
                        variant="secondary"
                        name="closePreviewBtn"
                        @click="cancel()"
                    >
                        Tutup
                    </b-button>
                    <b-button
                        v-if="selectedStatus == 2"
                        variant="pgiBtn"
                        name="closePreviewBtn"
                        :disabled="stateRefreshStatusCompletion.isLoading"
                        @click="onRefreshStatusCompletion()"
                    >
                        <i class="fa fa-refresh mr-1"></i> Refresh Status Lengkap {{ stateRefreshStatusCompletion.isLoading ? '...' : '' }}
                    </b-button>
                </template>

                <input
                    ref="cameraInput"
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style="display:none"
                    @change="handleKameraMobile"
                />
            </b-modal>


            <b-modal id="modal-loading" centered size="sm" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
                <h4 class="text-center text-lg">LOADING ...</h4>
            </b-modal>

        </b-card>
    </div>
</template>

<script>
import imageCompression from 'browser-image-compression';
export default {
    name: 'daftar-gadai',
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            input: {
                show: 10,
                filterNoFaktur: null,
                filterTipePelunasan: null,
                filterStatus: null,
                filterStartDate: null,
                filterEndDate: null,
                sortBy: null,
                sortDesc: null
            },
            fields: [
                { key: "noFaktur", label: "No. Faktur" },
                { key: "Barang", label: "Barang" },
                { key: "jumlahPinjaman", label: "Jumlah Pinjaman" },
                { key: "status", label: "Status" },
                { key: "tipePelunasan", label: "Tipe Pelunasan" },
                { key: "tanggalPelunasan", label: "Tanggal Pelunasan" },
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],
            activeItem: null,
            cabangOption: [],
            daftarPelunasan: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            cabangId: '',
            loading: false,
            query: "",


            activeFaktur: '',
            activeId: '',
            activeFotoPreview: '',

            sbgAwalGadai: {},
            sbgPelunasan: {},
            kwitansiPelunasan: {},
            notaHilang: {},

            required: [],

            loadDetail: false,
            activeFotoPreview: '',

            shouldRefresh: false,

            compressedFile: null,
            currentItem: null,
            stateRefreshStatusCompletion: {
                isLoading: false,
                isError: false,
            },
            selectedStatus: null,
        }
    },

    computed: {
        cabangIdStore() {
            return this.$store.state.readNotifstore.cabangId
        }
    },
    watch: {
        'cabangIdStore': function (newVal) {
            if (newVal != null) {
                this.page = 0
                this.input.show = 10
                this.query = this.$helper.makeQuery(this.page, this.input.show)
                this.getBuktiGadai()
            }
        }
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init() {

            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            this.cabangId = (this.cabangIdStore ? this.cabangIdStore : localStorage.getItem("activeCabangId"))
            this.query = this.query + "&cabangId=" + this.cabangId

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if (element.id != this.srcCabangId)
                        this.cabangOption.push(element)
                })
            })

            let getBuktiGadai = this.$axios.get("gadai-evidence/" + this.query).then(response => {
                this.daftarPelunasan = response.data.data
                this.updateTotalItem(response.data.total)
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getBuktiGadai, getCabang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                    this.toggleBusy()
                })
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getBuktiGadai() {
            this.toggleBusy()
            this.daftarPelunasan = []
            const params = this.buildQueryParams();

            this.$axios.get("gadai-evidence/", { params }).then(response => {
                this.daftarPelunasan = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.toggleBusy()
                    this.loading = false
                })


            this.shouldRefresh = false
        },

        detail(item) {

            this.loadDetail = true
            this.$bvModal.show('modal-detail')

            this.$axios.get("gadai-evidence/detail?gadaiId=" + item.id).then(response => {
                this.activeItem = response.data
                this.activeItem.noFaktur = item.noFaktur
                this.loadDetail = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.loadDetail = false
                    this.$bvModal.hide('modal-detail')
                })

        },

        viewFoto(item) {
            this.activeFotoPreview = item
            this.$bvModal.show("modal-preview-foto")
        },

        isPdfFile(item) {
            if (!item || !item.path) return false

            const path = item.path.toLowerCase()
            return path.includes('.pdf') || path.includes('application/pdf')
        },

        async prepareUploadFile(file) {
            if (!file || !file.type || !file.type.includes('image')) {
                return file
            }

            let controller = new AbortController();

            let options = {
                maxSizeMB: 1,
                signal: controller.signal,
            }

            try {
                let compressedFile = await imageCompression(file, options);
                return new File([compressedFile], file.name, { lastModified: new Date().getTime(), type: compressedFile.type })
            } catch (error) {
                console.log(error);
                return file
            }
        },
        clearSelectedFile(type) {
            const item = this.required.find((item) => item.type == type)
            if (item) {
                item.file = null
            }
        },

        fetchSBG(id) {
            this.$axios.get(`gadai-evidence/detail?evidenceId=${id}`)
                .then(response => {
                    for (let item of response.data.evidences) {
                        item.file = []
                    }
                    this.required = response.data.evidences
                    this.loadDetail = false
                }).catch(error => {
                    // Tindakan jika terjadi kesalahan
                    console.log(error);
                    this.$bvModal.hide('modal-upload-bukti')
                    this.$helper.toastErr(this, error.response.data.reason)
                    this.loadDetail = false
                    // this.initStatus = -1;
                });

        },

        uploadBukti(id, item, status) {
            this.activeFaktur = item
            this.activeId = id
            this.loadDetail = true
            this.selectedStatus = status
            this.$bvModal.show('modal-upload-bukti')

            this.fetchSBG(id)

        },

        async browseFile(type, file, upload = false, id) {
            if (file == null) {
                return
            }

            this.$bvModal.show("modal-loading")
            let formData = new FormData();

            let fileType = await this.prepareUploadFile(file);

            if (upload) {
                formData.append('id', id);
                formData.append('file', fileType);

                this.$axios.post(`gadai-evidence/update/`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.$helper.toastSucc(this, "Bukti berhasil diubah!")
                    this.fetchSBG(this.activeId)
                    this.$bvModal.hide("modal-loading")
                    this.clearSelectedFile(type)
                    this.currentItem = null;
                }).catch(error => {
                    // Tindakan jika terjadi kesalahan
                    console.log(error);
                    this.$helper.toastErr(this, error.response.data.reason)
                    this.$bvModal.hide("modal-loading")
                    this.clearSelectedFile(type)
                    this.currentItem = null;
                });
            } else {
                formData.append('noFaktur', this.activeFaktur);
                formData.append('type', type);
                formData.append('file', fileType);

                this.$axios.post(`gadai-evidence/insert`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.$helper.toastSucc(this, "Bukti berhasil diupload!")
                    this.fetchSBG(this.activeId)
                    this.$bvModal.hide("modal-loading")
                    this.clearSelectedFile(type)
                    this.currentItem = null;
                }).catch(error => {
                    // Tindakan jika terjadi kesalahan
                    console.log(error);
                    this.$helper.toastErr(this, error.response.data.reason)
                    this.$bvModal.hide("modal-loading")
                    this.clearSelectedFile(type)
                    this.currentItem = null;
                });
            }

            this.shouldRefresh = true
        },
        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange() {
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getBuktiGadai()
        },

        onPageChange() {
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getBuktiGadai()
            }
        },

        sortingChanged(ctx) {
            if (ctx.sortBy == "tanggalPelunasan") {
                this.input.sortBy = "createdAt"
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            } else if (ctx.sortBy != "") {
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset() {
            this.input.filterNoFaktur = null
            this.input.filterTipePelunasan = null
            this.input.filterStatus = null
            this.input.filterStartDate = null
            this.input.filterEndDate = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getBuktiGadai()
        },

        onFilter() {
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)

            this.loading = true
            this.getBuktiGadai()
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total) {
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        getDaftarBarangHilang() {
            this.$axios.get("gadai/barang-hilang-allowed").then(response => {
                if (response.data.id == 0) {
                    this.$helper.toastErr(this, "Tidak memiliki akses untuk melihat daftar barang hilang!")
                } else {
                    this.$router.push({ path: `${this.$route.path}/barang-hilang` })
                }
            })
        },

        onCamera(item) {
            this.currentItem = item;
            this.$refs.cameraInput.click();
        },

        handleKameraMobile(event) {
            const file = event.target.files[0];
            if (!file) return;

            const item = this.currentItem;
            this.browseFile(item.type, file, (item.path != null) && true, item.id);
        },

        onRefreshStatusCompletion() {
            this.stateRefreshStatusCompletion.isLoading = true;
            this.stateRefreshStatusCompletion.isError = false;

            const params = {
                noFaktur: this.activeFaktur,
            }

            this.$axios.post("gadai-evidence/refresh-completion-status", {}, { params }).then(response => {
                const data = response.data;
                if (data.id == 1) {
                    this.$helper.toastSucc(this, data.name)
                    this.getBuktiGadai()
                    this.$bvModal.hide('modal-upload-bukti')
                } else {
                    this.$helper.toastErr(this, data.name)
                }
            }).catch(error => {
                this.$helper.parseError(this, error)
                this.stateRefreshStatusCompletion.isError = true;
            }).finally(() => {
                this.stateRefreshStatusCompletion.isLoading = false;
            })
        },
        buildQueryParams() {
            this.cabangId = (this.cabangIdStore ? this.cabangIdStore : localStorage.getItem("activeCabangId"))

            const params = {
                page: this.currentPage - 1,
                size: this.perPage,
                cabangId: this.cabangId,
            }

            if (this.input.filterNoFaktur != null) {
                params.filterNoFaktur = this.input.filterNoFaktur;
            }

            if (this.input.filterTipePelunasan != null) {
                params.filterTipePelunasan = this.input.filterTipePelunasan;
            }

            if (this.input.filterStatus != null) {
                params.filterStatus = this.input.filterStatus;
            }

            if (!this.$helper.isNullOrEmpty(this.input.filterStartDate)) {
                params.filterStartDate = this.input.filterStartDate;
            }

            if (!this.$helper.isNullOrEmpty(this.input.filterEndDate)) {
                params.filterEndDate = this.input.filterEndDate;
            }

            if (this.input.sortBy != null) {
                params.sortBy = this.input.sortBy;
            }

            if (this.input.sortDesc != null) {
                params.sortDesc = this.input.sortDesc;
            }

            return params;
        }
    },

    created() {
        this.init()
    }
}
</script>
<style scoped>
.browse-foto {
    position: relative;
}

.browse-foto .custom-file {
    opacity: 0;
    z-index: 1;
}

.browse-foto .custom-file .custom-file-input {
    z-index: 0;
}

.browse-foto .custom-file .custom-file-label {
    cursor: pointer;
}

.browse-foto button {
    position: absolute;
    top: 0;
    left: 0;
}

.browse-foto {
    margin-right: 10px;
}

.upload-gadai-btn-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
}

.upload-gadai-btn {
    width: 150px;
    margin-right: 0px;
}

.alert-wrapper {
    margin-top: 22px;
}

.preview-pdf {
    width: 100%;
    min-height: 75vh;
    border: 0;
}

@media (max-width: 450px) {
    .upload-gadai-btn {
        width: 100%;
    }
}
</style>
